import { Pipe, PipeTransform } from "@angular/core";
import { GroupInterface } from "@core/interfaces/group.interface";
import { UtilsService } from "@core/services/utils/utils.service";

/**
 * Generates background colors for groups based on their category and name
 *
 * The colors are deterministic (same category+name always produces the same color)
 * and are designed to provide soft, pastel-like backgrounds with enough contrast
 * for readable text while fitting into the dark UI theme.
 */
@Pipe({ name: "groupBackgroundColor", pure: true })
export class GroupBackgroundColorPipe implements PipeTransform {
  transform(group: GroupInterface): string {
    if (!group || !group.category) {
      return "hsla(210, 50%, 50%, 0.5)"; // Default to a moderate blue
    }

    // Use category and name for more variation
    const hashString = `${group.category}-${group.name}`;
    const hash = UtilsService.stringToHash(hashString.toLowerCase());

    const hue = hash % 360;
    const saturation = 40 + (hash % 10); // 40-50% - Moderate saturation
    const lightness = 40 + (hash % 10); // 40-50% - Medium lightness for visibility

    return `hsla(${hue}, ${saturation}%, ${lightness}%, 0.5)`; // Moderate opacity
  }
}
